import { render, staticRenderFns } from "./DialogForRefuseDocument.vue?vue&type=template&id=233bbc5a&"
import script from "./DialogForRefuseDocument.vue?vue&type=script&lang=js&"
export * from "./DialogForRefuseDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports